import {
  RDX_KNOW_DATA_FETCH,
  RDX_KNOW_DATA_SAVE,
  RDX_KNOW_DATA_FETCH_DONE,
  RDX_KNOW_DATA_FETCH_ERR,
  RDX_KNOW_RESULT_FETCH_DONE,
  RDX_KNOW_PARAMS_FETCH,
  RDX_KNOW_PARAMS_UPDATE_FETCH,
  RDX_KNOW_RESULT_FETCH_ERR,
  RDX_KNOW_DATA_SAVE_DONE,
  RDX_KNOW_DATA_SAVE_ERR,
  RDX_KNOW_DATA_UPDATE,
  RDX_KNOW_DATA_UPDATE_DONE,
  RDX_KNOW_DATA_UPDATE_ERR,
  RDX_KNOW_DATA_CLEAN,
  RDX_KNOW_BACK_PARAMS_FETCH,
  RDX_KNOW_UPLOAD_CERTIFICATE,
  RDX_KNOW_UPLOAD_CERTIFICATE_DONE,
  RDX_KNOW_UPLOAD_CERTIFICATE_ERR,
  RDX_KNOW_SCORES_FETCH,
  RDX_KNOW_SCORES_FETCH_DONE,
  RDX_KNOW_DATA_GET_ERROR,
  RDX_KNOW_DATA_SAVE_SPINNER,
  RDX_KNOW_DATA_SAVE_DONE_SPINNER,
  RDX_KNOW_DATA_SAVE_ERR_SPINNER,
  RDX_KNOW_DATA_UPDATE_SPINNER,
  RDX_KNOW_DATA_UPDATE_DONE_SPINNER,
  RDX_KNOW_DATA_UPDATE_ERR_SPINNER,
  RDX_KNOW_DATA_SPINNER_LOADING_START,
  RDX_KNOW_DATA_SPINNER_LOADING_END,
  RDX_KNOW_DATA_FETCH_DONE_SPINNER,
  RDX_KNOW_DATA_FETCH_SPINNER,
} from './knowAction';

const initialState = {
  knowList: {},
  knowResult: {},
  knowScores: {},
  groupCodes: [],
  params: '',
  backQuery: '',
  saveResult: 0,
  uploadResult: 0,
  errorInfo: [],
  loadingBtn: false,
};

const know = (state = initialState, action) => {
  let newState = {...state};
  switch (action.type) {
    case RDX_KNOW_DATA_SPINNER_LOADING_START:
      newState = {...state, loadingBtn: true};
      return newState;
    case RDX_KNOW_DATA_SPINNER_LOADING_END:
      newState = {...state, loadingBtn: false};
      return newState;
    case RDX_KNOW_DATA_FETCH:
      newState = {...state, saveResult: 0, uploadResult: 0};
      return newState;
    case RDX_KNOW_DATA_FETCH_DONE:
      // newState = Object.assign({}, action.data);
      newState = {...state, knowList: action.data};
      return newState;
    case RDX_KNOW_DATA_FETCH_SPINNER:
      newState = {...state, saveResult: 0, uploadResult: 0};
      return newState;
    case RDX_KNOW_DATA_FETCH_DONE_SPINNER:
      // newState = Object.assign({}, action.data);
      newState = {...state, knowList: action.data};
      return newState;
    case RDX_KNOW_SCORES_FETCH:
      newState = {...state, knowResult: {}};
      return newState;
    case RDX_KNOW_SCORES_FETCH_DONE:
      newState = {...state, knowScores: action.data};
      return newState;
    case RDX_KNOW_RESULT_FETCH_DONE:
      newState = {...state, knowResult: action.data, saveResult: 0, uploadResult: 0, errorInfo: []};
      return newState;
    case RDX_KNOW_DATA_CLEAN:
      return state;
    case RDX_KNOW_PARAMS_FETCH:
      console.log('action.params=====', action.params);
      newState = {
        ...state,
        params: action.params,
        groupCodes: action.groupCodes,
        knowResult: action.knowResult,
        saveResult: 0,
        uploadResult: 0,
        errorInfo: [],
      };
      return newState;
    case RDX_KNOW_PARAMS_UPDATE_FETCH:
      newState = {
        ...state,
        params: action.params,
      };
      return newState;
    case RDX_KNOW_BACK_PARAMS_FETCH:
      newState = {...state, backQuery: action.params};
      return newState;
    case RDX_KNOW_DATA_FETCH_ERR:
      return state;
    case RDX_KNOW_RESULT_FETCH_ERR:
      return state;
    case RDX_KNOW_DATA_SAVE:
      return state;
    case RDX_KNOW_DATA_SAVE_DONE:
      newState = {...state, saveResult: action.data};
      return newState;
    case RDX_KNOW_DATA_SAVE_ERR:
      newState = {...state, saveResult: action.data, errorInfo: action.errorInfo};
      return newState;
    case RDX_KNOW_DATA_SAVE_SPINNER:
      return state;
    case RDX_KNOW_DATA_SAVE_DONE_SPINNER:
      newState = {...state, saveResult: action.data};
      return newState;
    case RDX_KNOW_DATA_SAVE_ERR_SPINNER:
      newState = {...state, saveResult: action.data, errorInfo: action.errorInfo};
      return newState;
    case RDX_KNOW_DATA_UPDATE:
      return state;
    case RDX_KNOW_DATA_UPDATE_DONE:
      newState = {...state, saveResult: action.data};
      return newState;
    case RDX_KNOW_DATA_UPDATE_ERR:
      newState = {...state, saveResult: action.data, errorInfo: action.errorInfo};
      return newState;
    case RDX_KNOW_DATA_UPDATE_SPINNER:
      return state;
    case RDX_KNOW_DATA_UPDATE_DONE_SPINNER:
      newState = {...state, saveResult: action.data};
      return newState;
    case RDX_KNOW_DATA_UPDATE_ERR_SPINNER:
      newState = {...state, saveResult: action.data, errorInfo: action.errorInfo};
      return newState;
    case RDX_KNOW_UPLOAD_CERTIFICATE:
      return state;
    case RDX_KNOW_UPLOAD_CERTIFICATE_DONE:
      newState = {...state, uploadResult: action.data};
      return newState;
    case RDX_KNOW_UPLOAD_CERTIFICATE_ERR:
      newState = {...state, uploadResult: action.data, errorInfo: action.errorInfo};
      return newState;
    case RDX_KNOW_DATA_GET_ERROR:
      newState = {...state, errorInfo: action.errorInfo};
      return newState;
    default:
      return state;
  }
};

export default know;
